import newsJA, { loadNewsJA } from './news_ja';
import newsZH, { loadNewsZH } from './news_zh';

const newsSources = {
  zh: {
    meta: newsZH,
    load: loadNewsZH,
  },
  ja: {
    meta: newsJA,
    load: loadNewsJA,
  },
};

export default newsSources;
